import React from "react";
import { useTranslation } from "react-i18next";
import { ViewStyle, useWindowDimensions } from "react-native";
import { Button } from "./ui/Button";
import GoogleIcon from "../assets/images/google-icon.svg";

interface GoogleSignInButtonProps {
  onPress: () => void;
  disabled?: boolean;
  style?: ViewStyle;
  square?: boolean;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onPress,
  disabled,
  style,
  square,
}) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width < 380; // Adjust breakpoint as needed

  if (square) {
    return (
      <Button
        onPress={onPress}
        disabled={disabled}
        accessibilityLabel={t("SIGN_IN_WITH_GOOGLE")}
        style={[
          {
            backgroundColor: "#fff",
            width: 56,
            height: 56,
            maxWidth: undefined,
            paddingHorizontal: 0,
            paddingVertical: 0,
            borderWidth: 1,
            borderColor: "#ccc",
          },
          style,
        ]}
        icon={<GoogleIcon width={24} height={24} />}
      />
    );
  }

  return (
    <Button
      onPress={onPress}
      disabled={disabled}
      text={isSmallScreen ? t("GOOGLE_SIGN_IN_SHORT") : t("SIGN_IN_WITH_GOOGLE")}
      style={[
        {
          backgroundColor: "#fff",
          width: "100%",
          maxWidth: 350,
          borderWidth: 1,
          borderColor: "#ccc",
        },
        style,
      ]}
      textStyle={{ color: "#000", fontWeight: "normal" }}
      icon={<GoogleIcon width={24} height={24} />}
    />
  );
};
